import { useEffect, useState } from 'react';

const useScrollByXToActive = (containerRef, activeTab) => {
  const [activeTabInternal, setActiveTabInternal] = useState(activeTab);

  useEffect(() => {
    if (!containerRef) {
      return;
    }

    const container = containerRef.current;

    const activeTabElement = container.querySelector(`[id="${activeTabInternal}"]`);

    if (!activeTabElement) {
      return;
    }

    const leftBound = activeTabElement.offsetLeft - container.offsetLeft;
    const rightBound =
      activeTabElement.offsetLeft - container.offsetLeft + activeTabElement.offsetWidth;

    const containerWidth = container.clientWidth;

    //Scroll to right if right side partially visible
    if (rightBound > containerWidth + container.scrollLeft) {
      container.scrollTo({
        left: rightBound - containerWidth + container.scrollLeft,
        behavior: 'smooth'
      });

      return;
    }

    //Scroll to left if left side partially visible
    if (leftBound < container.scrollLeft) {
      container.scrollTo({
        left: leftBound,
        behavior: 'smooth'
      });

      return;
    }
  }, [containerRef, activeTabInternal]);

  return setActiveTabInternal;
};

export default useScrollByXToActive;
